import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React from 'react';
import { isEmpty } from '../../helpers';
import classNames from 'classnames';
import Link from '../Link/Link';
var css = {
  "card": "rui-99hme",
  "cardContent": "rui-oN78c",
  "cardTitle": "rui-EB0t8",
  "cardImage": "rui-LdKdv"
};
var Card = /*#__PURE__*/function (_React$Component) {
  _inherits(Card, _React$Component);
  var _super = _createSuper(Card);
  function Card() {
    _classCallCheck(this, Card);
    return _super.apply(this, arguments);
  }
  _createClass(Card, [{
    key: "render",
    value: function render() {
      var _Card = /*#__PURE__*/React.createElement("div", {
        className: classNames([css.card, this.props.className]),
        onClick: this.props.onClick,
        style: this.props.style,
        onKeyPress: this.props.onClick,
        tabIndex: 0,
        role: "button"
      }, !isEmpty(this.props.image) && /*#__PURE__*/React.createElement("figure", {
        className: css.cardImage
      }, /*#__PURE__*/React.createElement("img", Object.assign({
        alt: ""
      }, this.props.image)), this.props.title && /*#__PURE__*/React.createElement("span", null, this.props.title)), !isEmpty(this.props.children) && /*#__PURE__*/React.createElement("div", {
        className: classNames([css.cardContent, this.props.contentClassName])
      }, this.props.title && isEmpty(this.props.image) && /*#__PURE__*/React.createElement("span", {
        className: css.cardTitle
      }, this.props.title), this.props.children));
      if (this.props.href) {
        _Card = /*#__PURE__*/React.createElement(Link, {
          to: this.props.href
        }, _Card);
      }
      return _Card;
    }
  }]);
  return Card;
}(React.Component);
Card.defaultProps = {
  style: {},
  className: '',
  contentClassName: '',
  onClick: function onClick() {},
  title: '',
  image: {},
  href: ''
};
export default Card;